export const copyToClipboard = (content) => {
  const el = document.createElement('textarea');
  el.value = content;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

export const icons = {
  blackCircle: '⚫ ',
  blueCircle: '🔵 ',
  orangeCircle: '🟠 ',
  purpleCircle: '🟣 ',
  whiteCircle: '⚪ ',
  yellowCircle: '🟡 ',
};

export const collapsedData = (data) => {
  const resArray = [];
  const res = data.reduce((acc, curr) => {
    if (!acc[curr.message]) acc[curr.message] = []; //If this type wasn't previously stored
    acc[curr.message].push(curr);
    resArray.push(acc[curr.message]);
    return acc;
  }, {});

  return { data: res, keys: Object.keys(res) };
};


export const getErrorMessageCount = (data) => data.filter((m) => m.messageType === 'error')
.length;

export const getScreenName = (slug) => {
  if (slug === 'Login') return 'Launch Pad';
  return slug.replace(/-/g, ' ');
};